import Hashids from 'hashids'

const PRIVATE_KEY = 'kits.ai'

const hashids = new Hashids(PRIVATE_KEY)

export const CryptoAPI = hashids
